import React from 'react';
import Alert from "@mui/material/Alert";


const AlertStepSkipped: React.FC<{ label: string}> = ({ label}) => {

    return (
        <Alert severity="warning">{label}</Alert>
    );
};

export default AlertStepSkipped;